﻿import { Utility } from '../Utility.js';
import { transform } from 'ol/proj';
import { register } from 'ol/proj/proj4.js';
import proj4 from 'proj4';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Circle as CircleStyle, Icon, Fill, Stroke, Style, Text } from 'ol/style';
import { WFS as WFSFormat, GML as GMLFormat, WKT, GeoJSON } from 'ol/format';
import Draw from 'ol/interaction/Draw';
import TileWMS from 'ol/source/TileWMS';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
export { AvimTool };

/**
 * Class Avim Tool
 */
const AvimTool = function () {

    // Define this
    var myAvimTool = this;

    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    // Utility
    this._utility = new Utility();

    // Ajax Result List
    this.ajaxResultList = [];

    // Ajax HTML code to inject
    this.ajaxInjection = {};

    // Ajax HTML code to inject counter
    this.ajaxInjectionCount = 0;

    // Address source tags
    this.sourceTags = [];

    // Layer point for draw interaction
    this._avimVectorPoint = null;

    // Draw point interaction
    this._drawPointNewgeom = null;

    // Choose location on map mode activated
    this._goToCoordinates = false;

    // Choose point on map tool activated flag
    this._markOnMapActivated = false;

    // Template for detail address
    this._ajaxTemplate = '<div class="row modal-avim-tool-info-detail-body" form-id="{{formid}}" criteria="{{Criteria}}">\
    <div class="col col-md-12">\
        <div class="col col-md-12">\
            <div class="form-group" style="margin-top: 10px;">\
                <label>Morada</label>\
                <input type="text" id="id-modal-avim-tool-info-detail-body-Morada" name="Morada" class="form-control" value="{{Morada}}" readonly>\
            </div>\
        </div>\
    </div>\
    <div class="col col-md-12">\
        <div class="col col-md-4">\
            <div class="form-group" style="margin-top: 10px;">\
                <label>Localidade</label>\
                <input type="text" id="id-modal-avim-tool-info-detail-body-Localidade" name="Localidade" class="form-control" value="{{Localidade}}" readonly>\
            </div>\
        </div>\
        <div class="col col-md-3">\
            <div class="form-group" style="margin-top: 10px;">\
                <label>Cód. Postal</label>\
                <input type="text" id="id-modal-avim-tool-info-detail-body-CodigoPostal" name="CodigoPostal" class="form-control" value="{{CodigoPostal}}" readonly>\
            </div>\
        </div>\
        <div class="col col-md-2">\
            <div class="form-group" style="margin-top: 10px;">\
                <label>Tipologia</label>\
                <input type="text" id="id-modal-avim-tool-info-detail-body-Tipologia" name="Tipologia" class="form-control" value="{{Tipologia}}" readonly>\
            </div>\
        </div>\
        <div class="col col-md-2">\
            <div class="form-group" style="margin-top: 10px;">\
                <label>Ano</label>\
                <input type="text" id="id-modal-avim-tool-info-detail-body-CaractConstrucaoAno" name="CaractConstrucaoAno" class="form-control" value="{{CaractConstrucaoAno}}" readonly>\
            </div>\
        </div>\
    </div>\
    <div class="col col-md-12">\
        <div class="col col-md-3">\
            <div class="form-group" style="margin-top: 10px;">\
                <label>Área B.C.A.</label>\
                <input type="text" id="id-modal-avim-tool-info-detail-body-AreaBrutaConstrucaoAjustada" name="AreaBrutaConstrucaoAjustada" class="form-control" value="{{AreaBrutaConstrucaoAjustada}}" readonly>\
            </div>\
        </div>\
        <div class="col col-md-3">\
            <div class="form-group" style="margin-top: 10px;">\
                <label>Data da Avaliação</label>\
                <input type="text" id="id-modal-avim-tool-info-detail-body-AvaliacaoData" name="AvaliacaoData" class="form-control" value="{{AvaliacaoData}}" readonly>\
            </div>\
        </div>\
        <div class="col col-md-3">\
            <div class="form-group" style="margin-top: 10px;">\
                <label>Tipo</label>\
                <input type="text" id="id-modal-avim-tool-info-detail-body-TipoAvaliacao" name="TipoAvaliacao" class="form-control" value="{{TipoAvaliacao}}" readonly>\
            </div>\
        </div>\
        <div class="col col-md-3">\
            <div class="form-group" style="margin-top: 10px;">\
                <label>Coeficiente</label>\
                <input type="text" id="id-modal-avim-tool-info-detail-body-Coeficiente" name="Coeficiente" class="form-control" value="{{Coeficiente}}" readonly>\
            </div>\
        </div>\
    </div>\
    <div class="col col-md-12">\
        <div class="col col-md-3">\
            <div class="form-group" style="margin-top: 10px;">\
                <label>Valor Aval.</label>\
                <input type="text" id="id-modal-avim-tool-info-detail-body-ValorActual" name="ValorActual" class="form-control" value="{{ValorActual}}" readonly>\
            </div>\
        </div>\
        <div class="col col-md-3">\
            <div class="form-group" style="margin-top: 10px;">\
                <label>V m<sup>2</sup> Homog.</label>\
                <input type="text" id="id-modal-avim-tool-info-detail-body-ValorM2" name="ValorM2" class="form-control" value="{{ValorM2}}" readonly>\
            </div>\
        </div>\
        <div class="col col-md-3">\
            <div class="form-group" style="margin-top: 10px;">\
                <label>Estimativa</label>\
                <input type="text" id="id-modal-avim-tool-info-detail-body-ValorM2Original" name="ValorM2Original" class="form-control" value="{{ValorM2Original}}" readonly>\
            </div>\
        </div>\
        <div class="col col-md-3">\
            <div class="form-group" style="margin-top: 10px;">\
                <label>Coeficiente Estimativa</label>\
                <input type="text" id="id-modal-avim-tool-info-detail-body-CoeficienteEstimativaM2" name="CoeficienteEstimativaM2" class="form-control" value="{{CoeficienteEstimativaM2}}" readonly>\
            </div>\
        </div>\
    </div>\
    </div>';

    // Simulation style pin
    this._styleSimulationLocation = [
        new Style({
            text: new Text({
                text: '\uf276',
                font: 'normal 32px FontAwesome',
                textBaseline: 'bottom',
                fill: new Fill({
                    color: 'red',
                }),
                stroke: new Stroke({
                    color: 'white',
                    width: 2
                })
            })
        })
    ];

    // Default highlight style
    this._limitHighlighStyles = [
        new Style({
            image: new CircleStyle({
                radius: 7,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 0, 0.7)',
                    width: 5
                })
            }),
            stroke: new Stroke({
                color: 'rgba(255, 255, 0, 0.2)',
                width: 14
            })
        })
    ];

    // Radius for simulation
    this._radiusSimulationSlider = null;

    // Index slider value
    this._valueRadiusSimulationInit = 500;

    // Min radius simulation
    this._minRadiusSimulation = 10;

    // Max radius simulation
    this._maxRadiusSimulation = 10000;

    // Hash with all reference value
    this._hashReference = {};

    // Hash properties set count
    this._hashCriteriaPropertiesInfo = {};

    // Hash google result
    // Score | Types           | location type
    //   1   | street_address  | GEOMETRIC_CENTER
    //   2   | route           | GEOMETRIC_CENTER
    //   3   | street_address  | RANGE_INTERPOLATED
    //   4   | route           | RANGE_INTERPOLATED
    //   5   | street_address  | ROOFTOP
    //   6   | route           | ROOFTOP
    this._resultGoogleScore =
    {
        "street_address_GEOMETRIC_CENTER": 1,
        "route_GEOMETRIC_CENTER": 2,
        "street_address_RANGE_INTERPOLATED": 3,
        "route_RANGE_INTERPOLATED": 4,
        "street_address_ROOFTOP": 4,
        "route_ROOFTOP": 5
    };
    

    // -- end private variable --------------------------------------------------------------------

    // -- begin public variable -------------------------------------------------------------------

    // -- end public variable ---------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Get all reference of avim tool
     */
    this.GetAllReference = function()
    {
        $.ajax({
            type: 'GET',
            url: '/rest/app/AvimTool/GetAllReference',
            xhrFields: {
                withCredentials: true
            },
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção de informação de referência");
                }
                else {
                    switch (data.result.status)
                    {
                        case "SUCCESS":
                            // -- Fill coeficiente obras beneficiacao -----------------------------
                            myAvimTool._hashReference["listCoeficienteObraBenificiacao"] = data.result.listCoeficienteObraBenificiacao;
                            myAvimTool._utility.FillSelect2Value("id-avim-search-select-obra-beneficiacao", myAvimTool._hashReference["listCoeficienteObraBenificiacao"], 'coeficienteObrasBeneficiacaoDesc', 'idCoeficienteObrasBeneficiacao', 'coeficienteObrasBeneficiacao', false);
                            // Set "N/A" id = 1
                            $('#id-avim-search-select-obra-beneficiacao').val("1").change();
                            // -- Fill Tipologia --------------------------------------------------
                            myAvimTool._hashReference["listTipologia"] = data.result.listTipologia;
                            myAvimTool._utility.FillSelect("id-avim-search-select-tipologia", myAvimTool._hashReference["listTipologia"], 'tipologiaDesc', 'tipologiaDesc', false);
                            break;
                        default:
                            toastr["error"]("Erro na obtenção de informação de referência");
                            break;
                    }
                }
            },
            error: function (request, status, error)
            {
                toastr["error"]("Erro na obtenção de informação de referência");
            }
        });
    }
    
    /**
     * Get geocode from google api
     */
    this.getGeoCodeLatLng = function (searchCoord, callback) {

        var APIKey = "AIzaSyCD-b2gYVtLMIMX6C79xEbspUWJcVhjQ3I&amp";
        var url = "https://maps.googleapis.com/maps/api/geocode/json?latlng=" + searchCoord[1] + "," + searchCoord[0];
        url += '&key=' + APIKey + '&callback=parseme';

        $.getJSON({
            url: url,
            data: {
                sensor: false
                //address: address
            },
            success: function (data, textStatus)
            {
                var address = {
                    streetAddress: "",
                    streetNo: "",
                    locality: ""
                };
                var infoAddress = {
                    score: 99,
                    result: null
                };
                var resultList = data.results;

                var projectionMap = myAvimTool._mapSgs._settings._mapSettings.map_info.srs_srid.toString();
                for (var i = 0; i < resultList.length; i++)
                {
                    var resultObj = resultList[i];
                    if( typeof resultObj.types !== "undefined")
                    {
                        var type = (resultObj.types.indexOf("street_address") >= 0)? "street_address": ((resultObj.types.indexOf("route") >= 0)?"route":"");
                        var locationType = ( resultObj.geometry !== undefined && resultObj.geometry.location_type !== undefined)?resultObj.geometry.location_type:"";
                        var key = type + "_" + locationType;
                        var score = myAvimTool._resultGoogleScore[key];
                        if( infoAddress.score > score )
                        {
                            infoAddress.score = score;
                            infoAddress.result = resultObj;
                        }
                    }
                }
                
                // Build result
                if(infoAddress.result !== null)
                {
                    // Get the street and number address and locality components
                    for (var j = 0; j < infoAddress.result.address_components.length; j++)
                    {
                        if (infoAddress.result.address_components[j].types.indexOf('route') != -1) {
                            address.streetAddress = infoAddress.result.address_components[j].long_name;
                        }
                        if (infoAddress.result.address_components[j].types.indexOf('street_number') != -1) {
                            address.streetNo = infoAddress.result.address_components[j].long_name;
                        }
                        if (infoAddress.result.address_components[j].types.indexOf('locality') != -1) {
                            address.locality = infoAddress.result.address_components[j].long_name;
                        }
                    }

                    if (typeof callback != "undefined") callback(address);
                }
            },
            error: function (request, status, error)
            {
                objAvimTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                toastr["error"]("Erro na localização");
            }
        });
    }

    /**
     * Get Api google location
     */
    this.gotoGeocode = function (searchData)
    {
        var APIKey = "AIzaSyCD-b2gYVtLMIMX6C79xEbspUWJcVhjQ3I&amp";
        var url = "https://maps.googleapis.com/maps/api/geocode/json?address=" + searchData;
        url += '&key=' + APIKey + '&callback=parseme';

        $.getJSON({
            url: url,
            data: {
                sensor: false
                //address: address
            },
            success: function (data, textStatus)
            {
                var projectionMap = myAvimTool._mapSgs._settings._mapSettings.map_info.srs_srid.toString();
                //var geocodeCoords = [data.results[0].geometry.location.lng, data.results[0].geometry.location.lat];
                //var geocodeLocationType = data.results[0].geometry.location_type;
                var geocodeExtentNE = 0;
                var geocodeExtentSW = 0;

                if (typeof data.results[0] != "undefined") {
                    var location = data.results[0].geometry.location;
                    var bounds = data.results[0].geometry.bounds;
                    if (typeof bounds != "undefined")
                    {
                        geocodeExtentNE = [data.results[0].geometry.viewport.northeast.lng, data.results[0].geometry.viewport.northeast.lat];
                        geocodeExtentSW = [data.results[0].geometry.viewport.southwest.lng, data.results[0].geometry.viewport.southwest.lat];
                        geocodeExtentNE = transform(geocodeExtentNE, 'EPSG:4326', 'EPSG:' + projectionMap);
                        geocodeExtentSW = transform(geocodeExtentSW, 'EPSG:4326', 'EPSG:' + projectionMap);
                        myAvimTool._mapSgs.map.getView().fit([geocodeExtentSW[0], geocodeExtentSW[1], geocodeExtentNE[0], geocodeExtentNE[1]], myAvimTool._mapSgs.map.getSize());
                        
                        var featureLocation = null;
                        if(data.results[0].geometry.location && data.results[0].geometry.location.lat && data.results[0].geometry.location.lng)
                        {
                            var coordinate = transform([data.results[0].geometry.location.lng, data.results[0].geometry.location.lat], 'EPSG:4326', 'EPSG:' + projectionMap);
                            featureLocation = new Feature({
                                geometry: new Point(coordinate),
                                name: 'Location'
                            });
                        }
                        else {

                            featureLocation = new Feature({
                                geometry: new Point(myAvimTool._mapSgs.map.getView().getCenter()),
                                name: 'Location'
                            });
                        }

                        // Clear previous selection
                        myAvimTool._ClearAllPinLocation();

                        // Localize position
                        myAvimTool._mapSgs.SetFeaturesHighlightByArray3(featureLocation, false, myAvimTool._styleSimulationLocation);

                    } else if (typeof location != "undefined") {

                        //myAvimTool._mapSgs.map.getView().setCenter(transform([data.results[0].geometry.location.lng, data.results[0].geometry.location.lat], 'EPSG:4326', 'EPSG:' + projectionMap));
                        //myAvimTool._mapSgs.map.getView().setZoom(11);


                        // Transform coordinate to map coordinate
                        var coordinate = transform([data.results[0].geometry.location.lng, data.results[0].geometry.location.lat], 'EPSG:4326', 'EPSG:' + projectionMap);
                        var featureLocation = new Feature({
                            geometry: new Point(coordinate),
                            name: 'Location'
                        });

                        // Clear previous selection
                        myAvimTool._ClearAllPinLocation();

                        // Localize position
                        myAvimTool._mapSgs.SetFeaturesHighlightByArray3(featureLocation, false, myAvimTool._styleSimulationLocation);
                    }
                }

                //if (geocodeLocationType != "ROOFTOP") {
                //    switch(geocodeLocationType)
                //    {
                //        case "APPROXIMATE":
                //            myAvimTool._mapSgs.map.getView().setCenter(transform([data.results[0].geometry.location.lng, data.results[0].geometry.location.lat], 'EPSG:4326', 'EPSG:' + projectionMap));
                //            myAvimTool._mapSgs.map.getView().setZoom(11);
                //            break;
                //        default:
                //            geocodeExtentNE = [data.results[0].geometry.bounds.northeast.lng, data.results[0].geometry.bounds.northeast.lat];
                //            geocodeExtentSW = [data.results[0].geometry.bounds.southwest.lng, data.results[0].geometry.bounds.southwest.lat];
                //    }
                //}
                //else {
                //    geocodeExtentNE = [data.results[0].geometry.viewport.northeast.lng, data.results[0].geometry.viewport.northeast.lat];
                //    geocodeExtentSW = [data.results[0].geometry.viewport.southwest.lng, data.results[0].geometry.viewport.southwest.lat];
                //}

                //geocodeExtentNE = transform(geocodeExtentNE, 'EPSG:4326', 'EPSG:' + projectionMap);
                //geocodeExtentSW = transform(geocodeExtentSW, 'EPSG:4326', 'EPSG:' + projectionMap);

                //myAvimTool._mapSgs.map.getView().fit([geocodeExtentSW[0], geocodeExtentSW[1], geocodeExtentNE[0], geocodeExtentNE[1]], myAvimTool._mapSgs.map.getSize());

            }
        });
    }

    /**
     * Run Simulation
     * Triggers the simulation process for FORM or ID simulation types, resulting in modal result presentation
     * 
     * @param {object} data - data.type = ID or FORM / data.feature ol Feature provided in case of ID type, undefined in case of FORM
     */
    this.RunSimulation = function (data)
    {
        myAvimTool.ajaxResultList = [];
        myAvimTool.ajaxInjection = {};
        var feature = typeof data.feature != 'undefined' ? data.feature : { values_: { Tipologia: $('#id-avim-search-select-tipologia').val(), AreaBrutaConstrucaoAjustada: $('#id-avim-search-bca').val() } };
        var simulationType = data.type;
        var ajaxOptions = {};
        switch (simulationType) {
            case "ID":
                ajaxOptions.url = '/rest/app/AvimTool/GetImovelByID?IDImovel=' + feature.values_.IDImovel;
                break;
            case "FORM":
                ajaxOptions.url = '/rest/app/AvimTool/GetImovelByForm';
                ajaxOptions.data = myAvimTool.getFormData($('#avim-search-form'));
                ajaxOptions.data.CoefHabitacaoCC = $('#id-avim-search-select-custo-controlado')[0].checked;
                ajaxOptions.data.CoefObrasBenef = parseFloat($('#id-avim-search-select-obra-beneficiacao').find("option:selected").attr('value2'));
                // Compose address
                ajaxOptions.data.Address = ajaxOptions.data.rua + " " + ajaxOptions.data.porta + " " + ajaxOptions.data.andar;
                break;
            default:
                url = '/rest/app/AvimTool/GetImovelByID?IDImovel=' + feature.values_.IDImovel;
        }

        ajaxOptions.type = 'GET';
        ajaxOptions.async = true;
        ajaxOptions.dataType = 'json';
        ajaxOptions.xhrFields =  {
                withCredentials: true
        };
        ajaxOptions.success = function (data) {

            if (typeof data.result == 'undefined' || typeof data.result.res == 'undefined' || data.result.res == '') {

                toastr["warning"]("Não existe informação para esta localização");
                myAvimTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', false);

            } else
            {
                // Activate close button
                $('.id-modal-avim-tool-close').off('click').on('click', function () {
                    $('#id-modal-simulation-avim').hide();
                });

                // For simulation through ID
                if (simulationType == "ID")
                {
                    // Set visible data
                    $('#id-modal-avim-imovel-tab').text("Imóvel");
                    $('#id-modal-avim-morada-label').text("Morada");
                    $("#modal-avim-tool-field-numporta").removeClass().addClass('col').addClass('col-md-4').prop('readonly', true);
                    $("#modal-avim-tool-field-tipoporta").removeClass().addClass('hidden').prop('readonly', true);
                    $("#modal-avim-tool-field-andar").removeClass().addClass('col').addClass('col-md-4').prop('readonly', true);
                    $("#modal-avim-tool-field-lado").removeClass().addClass('col').addClass('col-md-4').prop('readonly', true);
                    $("#modal-avim-tool-field-aba").removeClass().addClass('col').addClass('col-md-6').prop('readonly', true);
                    $("#modal-avim-tool-field-abp").removeClass().addClass('col').addClass('col-md-6').prop('readonly', true);
                    $("#modal-avim-tool-field-tipologia").removeClass().addClass('hidden').prop('readonly', true);

                    // Fill main data
                    $('#id-modal-avim-tool-imovel-body-ArteriaNome').val(feature.values_.Morada).prop('readonly', true);
                    $('#id-modal-avim-tool-imovel-body-PortaNumero').val(feature.values_.PortaNumero).prop('readonly', true);
                    $('#id-modal-avim-tool-imovel-body-AndarNumero').val(feature.values_.AndarNumero).prop('readonly', true);
                    $('#id-modal-avim-tool-imovel-body-AndarLado').val(feature.values_.AndarLado).prop('readonly', true);
                    $('#id-modal-avim-tool-imovel-body-CodigoPostal').val(feature.values_.CodigoPostal1 + "-" + feature.values_.CodigoPostal2).prop('readonly', true);
                    $('#id-modal-avim-tool-imovel-body-Localidade').val(feature.values_.Localidade).prop('readonly', true);
                    $('#id-modal-avim-tool-imovel-body-DesignacaoPostal').val(feature.values_.DesignacaoPostal).prop('readonly', true);
                    $('#id-modal-avim-tool-imovel-body-Tipologia').val(feature.values_.Tipologia).prop('readonly', true);
                    $('#id-modal-avim-tool-imovel-body-AreaBrutaConstrucaoAjustada').val(feature.values_.AreaBrutaConstrucaoAjustada).prop('readonly', true);
                    $('#id-modal-avim-tool-imovel-body-CaractConstrucaoAno').val(feature.values_.CaractConstrucaoAno).prop('readonly', true);
                    $('#id-modal-avim-tool-imovel-body-TipoBem').val(feature.values_.TipoBem).prop('readonly', true);
                    $('#id-modal-avim-tool-imovel-body-Tipologia').val(feature.values_.Tipologia).prop('readonly', true);

                } else
                {
                    // Set visible data
                    $('#id-modal-avim-imovel-tab').text("Dados Pesquisa");
                    $('#id-modal-avim-morada-label').text("Morada");
                    $("#modal-avim-tool-field-numporta").removeClass().addClass('col').addClass('col-md-6').prop('readonly', true);
                    $("#modal-avim-tool-field-tipoporta").removeClass().addClass('hidden').prop('readonly', true);
                    $("#modal-avim-tool-field-andar").removeClass().addClass('col').addClass('col-md-6').prop('readonly', true);
                    $("#modal-avim-tool-field-lado").removeClass().addClass('hidden').prop('readonly', true);
                    $("#modal-avim-tool-field-aba").removeClass().addClass('col').addClass('col-md-6').prop('readonly', true);
                    $("#modal-avim-tool-field-abp").removeClass().addClass('hidden').prop('readonly', true);
                    $("#modal-avim-tool-field-tipologia").removeClass().addClass('col').addClass('col-md-6').prop('readonly', true);

                    // Fill main data
                    $('#id-modal-avim-tool-imovel-body-ArteriaNome').val($('#id-search-avim-address').val()).prop('readonly', true);
                    $('#id-modal-avim-tool-imovel-body-PortaNumero').val($('#id-avim-search-porta').val()).prop('readonly', true);
                    $('#id-modal-avim-tool-imovel-body-AndarNumero').val($('#id-avim-search-andar').val()).prop('readonly', true);
                    $('#id-modal-avim-tool-imovel-body-CodigoPostal').val($('#id-avim-search-select-cp4').val() + '-' + $('#id-avim-search-select-cp3').val()).prop('readonly', true);
                    $('#id-modal-avim-tool-imovel-body-Localidade').val($('#id-avim-search-select-localidade').val()).prop('readonly', true);
                    $('#id-modal-avim-tool-imovel-body-DesignacaoPostal').val($('#id-avim-search-select-designa-postal').val()).prop('readonly', true);
                    $('#id-modal-avim-tool-imovel-body-AreaBrutaConstrucaoAjustada').val($('#id-avim-search-bca').val()).prop('readonly', true);
                    $('#id-modal-avim-tool-imovel-body-CaractConstrucaoAno').val($('#id-avim-search-select-ano-construcao').val()).prop('readonly', true);
                    $('#id-modal-avim-tool-imovel-body-TipoBem').val($('#id-avim-search-select-tipo').val()).prop('readonly', true);
                    $('#id-modal-avim-tool-imovel-body-tipologia').val($('#id-avim-search-select-tipologia').val()).prop('readonly', true);
                }

                var imovelDataList = data.result.res.split('|'); // Get different imovel detail info

                // Clear detail info areas
                $(".modal-avim-tool-info-predio-detail").empty();
                $(".modal-avim-tool-info-rua-detail").empty();
                $(".modal-avim-tool-info-proximidade-detail").empty();

                myAvimTool.ajaxInjectionCount = imovelDataList.length-1; // Dont count with "ponderação"

                // For each criteria, prepare each tab info to display
                for (var i = 0; i < imovelDataList.length; i++)
                {
                    var imovelData = imovelDataList[i];
                    var imovelDataParts = imovelData.split('#');
                    var imovelDetails = imovelDataParts[0].split(';');
                    var imovelDetailImovelList = imovelDataParts[1].trim();
                    var criteria = imovelDetails[0].split(':')[0].trim();
                    if(criteria === "Ponderação")
                        criteria = "ponderacao";
                    var anoConstrucao = (feature.values_.CaractConstrucaoAno != undefined && feature.values_.CaractConstrucaoAno != "" && feature.values_.CaractConstrucaoAno != null)?feature.values_.CaractConstrucaoAno:"0"; // No Ano de Construção to send

                    // Fill detail data
                    var desvioPadrao = "";
                    if(criteria !== "ponderacao")
                    {
                        desvioPadrao = imovelDetails[2].split(':')[1].trim().replace(",", ".");
                    }
                    var valorAtual = imovelDetails[0].split(':')[1].trim().replace(",", ".");
                    var valorAtualMedio = imovelDetails[1].split(':')[1].trim().replace(",", ".");
                    var radius = "";
                    if(criteria === "Proximidade")
                    {
                        radius = imovelDetails[3].split(':')[1].trim().replace(",", ".");
                        $('#id-modal-avim-tool-' + criteria.toLowerCase() + '-body-radius').val(radius).prop('readonly', true);
                    }
                    if(criteria !== "ponderacao")
                        $('#id-modal-avim-tool-' + criteria.toLowerCase() + '-body-desvio-padrao').val(myAvimTool._FormatNumberToMoney(desvioPadrao)).prop('readonly', true);
                    $('#id-modal-avim-tool-' + criteria.toLowerCase() + '-body-valor').val(myAvimTool._FormatNumberToMoney(valorAtual)).prop('readonly', true);
                    $('#id-modal-avim-tool-' + criteria.toLowerCase() + '-body-valor-medio').val(myAvimTool._FormatNumberToMoney(valorAtualMedio)).prop('readonly', true);

                    if(criteria === "ponderacao")
                    {
                        if(imovelDetails[2])
                            $('#id-modal-avim-tool-' + criteria.toLowerCase() + '-body-peso').val(imovelDetails[2].split(':')[1].trim()).prop('readonly', true);
                        if(imovelDetails[3])
                            $('#id-modal-avim-tool-' + criteria.toLowerCase() + '-body-coeficientes').val(imovelDetails[3].split(':')[1].trim()).prop('readonly', true);
                    }

                    // -- Fetch Imovel Info list --------------------------------------------------
                    var imovelListArray = [];
                    var fullImovelList = imovelDetailImovelList.split(',');

                    // If imovel ID list is bigger than 1800, decompose it in two requests to avoid URL max length breach
                    if(imovelDetailImovelList !== "")
                    {
                        // Active spinner for wait for list properties
                        switch(criteria.toLowerCase())
                        {
                            case "predio":
                                $('#id-modal-avim-tool-info-predio-detail-spinner').show();
                                break;
                            case "rua":
                                $('#id-modal-avim-tool-info-rua-detail-spinner').show();
                                break;
                            case "proximidade":
                                $('#id-modal-avim-tool-info-proximidade-detail-spinner').show();
                                break;
                            default:
                                // do nothing
                        }

                        if (imovelDetailImovelList.length > 1800) {
                            myAvimTool.ajaxInjectionCount++;
                            var half = Math.ceil(fullImovelList.length / 2);
                            imovelListArray.push(fullImovelList.splice(0, half).join(','));
                            imovelListArray.push(fullImovelList.splice(-half).join(','));
                        } else {
                            imovelListArray.push(fullImovelList.join(','));
                        }
                        myAvimTool._hashCriteriaPropertiesInfo[criteria.toLowerCase()] = {
                            countList: imovelListArray.length
                        };

                        for (var k = 0; k < imovelListArray.length; k++) {
                            // Fetch Imovel detail info by criteria
                            $.ajax({
                                type: 'GET',
                                url: '/rest/app/AvimTool/GetCriteriaGetDataSourceSimulacao?criteria=' + criteria + '&idImoveis=' + imovelListArray[k] + '&tipologia=' + ((feature.values_.Tipologia != undefined && feature.values_.Tipologia != "" && feature.values_.Tipologia != null) ? feature.values_.Tipologia : "\'\'") + '&AnoConstrucao=' + anoConstrucao + '&AreaBrutaConstrucaoAjustada=' + feature.values_.AreaBrutaConstrucaoAjustada,
                                async: true,
                                xhrFields: {
                                    withCredentials: true
                                },
                                dataType: 'json',
                                success: function (data)
                                {
                                    // Account for tab resolved
                                    myAvimTool.ajaxInjectionCount = myAvimTool.ajaxInjectionCount - 1;

                                    // Decrease criteria list count
                                    myAvimTool._hashCriteriaPropertiesInfo[data.result.criteria.toLowerCase()].countList--;

                                    if (typeof data.result == 'undefined' || typeof data.result.res == 'undefined' || data.result.res == '' || data.result.res == 'ERROR')
                                    {
                                        // Active spinner for wait for list properties
                                        switch(data.result.criteria.toLowerCase())
                                        {
                                            case "predio":
                                                toastr["error"]("Erro ao obter informação de imóveis do critério predio");
                                                if(k === imovelListArray.length-1)
                                                    $('#id-modal-avim-tool-info-predio-detail-spinner').hide();
                                                break;
                                            case "rua":
                                                toastr["error"]("Erro ao simular");
                                                if(k === imovelListArray.length-1)
                                                    $('#id-modal-avim-tool-info-rua-detail-spinner').hide();
                                                break;
                                            case "proximidade":
                                                toastr["error"]("Erro ao simular");
                                                if(k === imovelListArray.length-1)
                                                    $('#id-modal-avim-tool-info-proximidade-detail-spinner').hide();
                                                break;
                                            default:
                                                // do nothing
                                        }
                                    }
                                    else
                                    {
                                        // Fetch each detail imovel info
                                        var detailImovelString = data.result.res;
                                        var criteria = data.result.criteria;
                                        var imovelDataList = JSON.parse(detailImovelString)["diffgr:diffgram"];

                                        // Reset detail addresses area
                                        $('.' + criteria.toLowerCase() + '-lista-moradas').removeClass('hidden');

                                        // For given criteria, load detail addresses info
                                        if (typeof imovelDataList != "undefined" && typeof imovelDataList["NewDataSet"] != "undefined")
                                        {
                                            imovelDataList = imovelDataList["NewDataSet"]["Table"];

                                            if (typeof imovelDataList.length == "undefined") imovelDataList = [imovelDataList]; // Fix for single record

                                            for (var k = 0; k < imovelDataList.length; k++)
                                            {
                                                // Get imovel detail data to template
                                                var imovelDetailData = imovelDataList[k];
                                                // Add specific imovel data
                                                imovelDetailData["formid"] = k;
                                                imovelDetailData["Criteria"] = criteria.toLowerCase();
                                                // Fix date format
                                                imovelDetailData["AvaliacaoData"] = imovelDetailData["AvaliacaoData"].split('T')[0];
                                                // Fix decimal places
                                                imovelDetailData["ValorM2"] = typeof imovelDetailData["ValorM2"] == "undefined" ? "0" : imovelDetailData["ValorM2"];
                                                imovelDetailData["ValorActual"] = typeof imovelDetailData["ValorActual"] == "undefined" ? "0" : imovelDetailData["ValorActual"];
                                                imovelDetailData["ValorM2Original"] = typeof imovelDetailData["ValorM2Original"] == "undefined" ? "0" : imovelDetailData["ValorM2Original"];
                                                if (imovelDetailData["ValorM2"].indexOf(".") != -1) imovelDetailData["ValorM2"] = myAvimTool._FormatNumberToMoney(imovelDetailData["ValorM2"]);
                                                if (imovelDetailData["ValorActual"].indexOf(".") != -1) imovelDetailData["ValorActual"] = myAvimTool._FormatNumberToMoney(imovelDetailData["ValorActual"]);
                                                if (imovelDetailData["ValorM2Original"].indexOf(".") != -1) imovelDetailData["ValorM2Original"] = myAvimTool._FormatNumberToMoney(imovelDetailData["ValorM2Original"]);
                                                if (imovelDetailData["CoeficienteEstimativaM2"].indexOf(".") != -1) imovelDetailData["CoeficienteEstimativaM2"] = myAvimTool._FormatNumberToMoney(imovelDetailData["CoeficienteEstimativaM2"]);
                                                // Call template with new data
                                                myAvimTool.loadImovelDetail(myAvimTool._GetAjaxTemplate(imovelDetailData));
                                            }

                                            // When all injection colection has been done, load data to DOM and show modal
                                            if (myAvimTool.ajaxInjectionCount == 0) {

                                                // Append ajax results to DOM
                                                $.each(myAvimTool.ajaxInjection, function (key, value) {
                                                    $(".modal-avim-tool-info-" + key + "-detail").append(value);
                                                });

                                                // All tabs resolved - Open modal
                                                $('#id-modal-simulation-avim').show();
                                                myAvimTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                                            }

                                        } else {
                                            // If no info for given criteria, hide detail info title on modal
                                            $('.' + criteria.toLowerCase() + '-lista-moradas').addClass('hidden');
                                        }

                                        // Desactive spinner for wait for list properties
                                        if( myAvimTool._hashCriteriaPropertiesInfo[criteria.toLowerCase()].countList === 0)
                                        {
                                            $('#id-modal-avim-tool-info-' + criteria.toLowerCase() + '-detail-spinner').hide();
                                        }
                                    }
                                },
                                error: function (request, status, error) {

                                    toastr["error"]("Erro ao simular");

                                    myAvimTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                                }
                            });
                        }
                    }
                }

                // Show modal with simultation
                $('#id-modal-simulation-avim').show()

                // Stop 
                myAvimTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', false);
            }
        }
        ajaxOptions.error = function (request, status, error)
        {
            toastr["error"]("Erro ao simular");

            myAvimTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', false);
        }

        myAvimTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', true);

        $.ajax(ajaxOptions);
    }

    /**
     * Get Form Data
     * Triggers the simulation process for FORM or ID simulation types, resulting in modal result presentation
     * 
     * @param {object} data - data.type = ID or FORM / data.feature ol Feature provided in case of ID type, undefined in case of FORM
     */
    this.getFormData = function ($form) {
        var unindexed_array = $form.serializeArray();
        var indexed_array = {};

        $.map(unindexed_array, function (n, i) {
            var value = n['value'];
            if ((n['name'] == "AreaBrutaConstrucaoAjustada" || n['name'] == "AnoConstrucao") && value == "") value = 0;
            indexed_array[n['name']] = value;
        });

        return indexed_array;
    }

    /**
     * Get Form Data
     * Triggers the simulation process for FORM or ID simulation types, resulting in modal result presentation
     * 
     * @param {object} data - data.type = ID or FORM / data.feature ol Feature provided in case of ID type, undefined in case of FORM
     */
    this.getNumericPorta = function (porta) {
        var numericPorta = "";
        porta = porta.toString();
        for (var j = 0; j < porta.length; j++) {
            if (!isNaN(porta[j])) numericPorta += porta[j];
            if (isNaN(porta[j])) break;
        }
        return parseInt(numericPorta);
    }

    /**
     * Execute action from adicional parameter
     */
    this.ExecuteAdicionalParameter = function () {
        // Get adicional parameters
        var addicionalParams = this._mapSgs._settings._mapSettings.additional_params;

        // Goto do property by name
        if (addicionalParams && addicionalParams.context === "Avim" && addicionalParams.type === "byIdImmobile" && addicionalParams.id) {

            // Get layer info
            var layerInfo = myAvimTool._mapSgs.layerTree.FindLayerInfoOnListLayer("GP_Imovel");

            // Active layer properties
            myAvimTool._mapSgs.layerTree.layerTreeObj.check(myAvimTool._mapSgs.layerTree.layerTreeObj.getNodeById(layerInfo.id.toString()));

            // Show properties
            myAvimTool._SetSearchResultFromLayer(layerInfo, "IDImovel=='" + addicionalParams.id + "'", false);
        }

        // View all properties of a simulation
        if (addicionalParams && addicionalParams.context === "Avim" && addicionalParams.type === "bySimulation" && addicionalParams.imguid && addicionalParams.epsg && addicionalParams.latitude && addicionalParams.longitude) {
            // Mark Location
            var coordinate = transform([parseFloat(addicionalParams.longitude.replace(",", ".")), parseFloat(addicionalParams.latitude.replace(",", "."))], 'EPSG:' + addicionalParams.epsg, 'EPSG:' + myAvimTool._mapSgs._settings._mapSettings.map_info.srs_srid);
            var featureLocation = new Feature({
                geometry: new Point(coordinate),
                name: 'Location'
            });
            myAvimTool._mapSgs.SetFeaturesHighlightByArray3(featureLocation, false, myAvimTool._styleSimulationLocation);

            // Show all properties from simulation
            var layerInfo = myAvimTool._mapSgs.layerTree.FindLayerInfoOnListLayer("v_SimulGeoportal2");
            myAvimTool._SetSearchResultFromLayer(layerInfo, "SimulGUID=='" + addicionalParams.imguid + "'", false);

            // Active all properties
            var layerInfo = myAvimTool._mapSgs.layerTree.FindLayerInfoOnListLayer("v_SimulGeoportal2");
            myAvimTool._mapSgs.layerTree.layerTreeObj.check(myAvimTool._mapSgs.layerTree.layerTreeObj.getNodeById(layerInfo.id.toString()));
        }
    }

    /**
     * Wait for distrito combo
     * @param {bool} wait, true for wait
     */
    this.SelectSearchDistritoWait = function(wait)
    {
        if(wait)
        {
            $('#id-avim-search-select-distrito-spin').show();
            $('#id-avim-search-select-distrito').prop('disabled', true);
        }
        else
        {
            $('#id-avim-search-select-distrito-spin').hide();
            $('#id-avim-search-select-distrito').prop('disabled', false);
        }
        $('#id-avim-search-select-distrito').selectpicker('refresh');
    }

    /**
     * Wait for concelho combo
     * @param {bool} wait, true for wait
     */
    this.SelectSearchConcelhoWait = function(wait)
    {
        if(wait)
        {
            $('#id-avim-search-select-concelho-spin').show();
            $('#id-avim-search-select-concelho').prop('disabled', true);
        }
        else
        {
            $('#id-avim-search-select-concelho-spin').hide();
            $('#id-avim-search-select-concelho').prop('disabled', false);
        }
        $('#id-avim-search-select-concelho').selectpicker('refresh');
    }

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------
    
    /**
     * Convert number to xxx,xxx,xxx.xx €
     * @param {string} numberInString, number to format in string type
     */
    this._FormatNumberToMoney = function (numberInString)
    {
        var result = "";
        if(numberInString && numberInString !== "")
            result = parseFloat(numberInString).toFixed(2).replace(".", ",").replace(/\d(?=(\d{3})+\,)/g, '$&.').replace(",00", "") + " €";
        
        return result;
    };

    /**
     * Clear all pin location of a properties 
     */
    this._ClearAllPinLocation = function()
    {
        // Remove pin added by address selection
        myAvimTool._mapSgs.featureToHighLight.clear();

        // Remove pin added by click in map
        myAvimTool._avimVectorPoint.getSource().clear();
    }

    /**
     * Concelho Callback
     * Instructions to update Concelho and Localidade during 'Choose on map' functionality
     */
    this.concelhoCallback = function () {

        var localidadeSelect = $('#id-avim-search-select-localidade');
        var freguesiaExists = false;
        var concelhoExists = false;
        var concelho = $('#id-avim-search-select-concelho option:selected').text();
        var freguesia = typeof myAvimTool.freguesiaVal != 'undefined' ? myAvimTool.freguesiaVal : "";
        for (var o = 0; o < localidadeSelect.find('option').length; o++) {
            if ($(localidadeSelect.find('option')[o]).text() == freguesia && freguesia != "") freguesiaExists = true;
            if ($(localidadeSelect.find('option')[o]).text() == concelho && concelho != "") concelhoExists = true;
        }

        if (typeof myAvimTool._mapSgs.searchCoord != "undefined")
        {
            myAvimTool.getGeoCodeLatLng(myAvimTool._mapSgs.searchCoord, function (address)
            {
                myAvimTool._mapSgs.chosenAddress = address;
                if (typeof myAvimTool._mapSgs.chosenAddress != "undefined" && typeof myAvimTool._mapSgs.chosenAddress.locality != "undefined") {
                    $('#id-avim-search-select-localidade').val(myAvimTool._mapSgs.chosenAddress.locality);
                }
                if (freguesiaExists) {
                    $('#id-avim-search-select-localidade').val(freguesia);
                } else if (concelhoExists) {
                    $('#id-avim-search-select-localidade').val($('#id-avim-search-select-concelho option:selected').text());
                }
                $('#id-avim-search-select-localidade').selectpicker("refresh");
                $('#id-avim-search-select-localidade').trigger('change.bs.select');

            });
        }
    }

    /**
     * Distrito Callback
     * Instructions to update Distrito and Concelho during 'Choose on map' functionality
     */
    this.distritoCallback = function () { // Callback for distrito change

        myAvimTool.change_select_callback = myAvimTool.concelhoCallback;
        myAvimTool.concelhoSelect.val(myAvimTool.dd + myAvimTool.cc);
        myAvimTool.concelhoSelect.selectpicker("refresh");
        myAvimTool.concelhoSelect.trigger('change.bs.select');

        myAvimTool._goToCoordinates = false;
    }

    /**
     * Replace First Connective Word
     * Replaces first connective word on a string
     *
     * @param {string} originalString, The string to modify
     * @returns {string, bool} newString, even if not modified; moreParticlesToReplace true if there are more connective particles left to remove
     */
    this.replaceFirstConnectiveWord = function (originalString) {

        var newAddress = originalString;
        var replaceParticles = [" de ", " da ", " do ", " das ", " dos ", " ao ", " aos ", " à ", " às "];
        var particlesToReplaceCount = 0
        var firstParticleIndex = -1;
        for (var p = 0; p < replaceParticles.length; p++) {
            var replaceParticlePosition = originalString.indexOf(replaceParticles[p]);
            if (replaceParticlePosition != -1) {
                particlesToReplaceCount++;
                if (replaceParticlePosition < firstParticleIndex || firstParticleIndex == -1)
                    firstParticleIndex = p;
            }
        }

        if (firstParticleIndex != -1) {
            newAddress = originalString.replace(replaceParticles[firstParticleIndex], " ").trim();
        } 

        return { newAddress: newAddress, moreParticlesToReplace: particlesToReplaceCount > 1 };


    }

    /**
     * Update Autocomplete
     * Updates the source for a jquery ui autocomplete field
     * 
     * @param {string} fieldSelector, The selector for the field
     * @param array of {object} sourceTags, A list with the source to add
     * @param {string} tagField, The name for the main autocomplete field
     */
    myAvimTool.updateAutocomplete = function (fieldSelector, sourceTags, tagField) {

        $(fieldSelector).autocomplete({
            source: function (request, response) {
                var results = sourceTags.filter(r=> myAvimTool._utility.RemoveAccents(r[tagField].toUpperCase()).includes(myAvimTool._utility.RemoveAccents(request.term.toUpperCase())));
                var uniqueResults = [];
                $.each(results, function (i, el) {
                    if ($.inArray(el.morada, uniqueResults) === -1) uniqueResults.push(el.morada);
                });
                response(uniqueResults.slice(0, 10));
            },
            select: function triggerResult(event, ui) {
                // Navigate map to location
                myAvimTool.gotoGeocode(ui.item.label + "," + myAvimTool.localidadeVal + ", " + myAvimTool.concelhoVal + ", " + myAvimTool.distritoVal + ", Portugal");

                $('#id-avim-search-porta').val("");
                $('#id-avim-search-andar').val("");
                $('#id-avim-search-select-cp4').val("");
                $('#id-avim-search-select-cp3').val("");
                var addressTag =sourceTags.filter(s => s[tagField].toUpperCase() == ui.item.label.toUpperCase());
                if (addressTag.length > 0) {
                    $("#id-avim-search-select-cp4").val(addressTag[0].cp4);
                    $("#id-avim-search-select-designa-postal").val(addressTag[0].designa);
                    if (addressTag.length == 1) {
                        $("#id-avim-search-select-cp3").val(addressTag[0].cp3);
                    }
                }
            },
            change: function triggerResult(event, ui) {

                $('#id-avim-search-porta').val("");
                $('#id-avim-search-andar').val("");
                $('#id-avim-search-select-cp4').val("");
                $('#id-avim-search-select-cp3').val("");
                var addressTag = sourceTags.filter(s => s[tagField].toUpperCase() == $("#id-search-avim-address").val().toUpperCase());
                if (addressTag.length > 0) {
                    $("#id-avim-search-select-cp4").val(addressTag[0].cp4);
                    $("#id-avim-search-select-designa-postal").val(addressTag[0].designa);
                    if (addressTag.length == 1) {
                        $("#id-avim-search-select-cp3").val(addressTag[0].cp3);
                    }
                }
                if ($("#id-avim-search-porta").val() != "") $("#id-avim-search-porta").trigger('change');
            }
        });

    }

    /**
     * Set search in layer by cqlFilter
     * @param {object} layerInfo, All the information of the layer
     * @param {string} cqlFilter
     * @param {bool} clearHighight, clear hight light from previous selection
     */
    this._SetSearchResultFromLayer = function (layerInfo, cqlFilter, clearHighight) {
        // Start wait
        myAvimTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', true);

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: layerInfo.geoserver + "/wfs",
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": layerInfo.workspace + ':' + layerInfo.layerName,
                "cql_filter": cqlFilter,
                'srsName': myAvimTool._mapSgs._settings.projection.code_,
                "outputFormat": 'application/json',
                "maxFeatures": 200
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length > 0) {
                    if (clearHighight && myAvimTool._mapSgs.featureToHighLight.getLength() > 0) myAvimTool._mapSgs.featureToHighLight.clear();
                    myAvimTool._mapSgs._arraySearchLayerFeatureActive = [];
                    var feature = null;
                    var idLayer = layerInfo.id;
                    var layerName = layerInfo.layerName;
                    var workspace = layerInfo.workspace;
                    var columnDefArray = [];
                    var columDefArrayExpand = [];
                    var columDefArrayExpandSize = [];
                    var columnValueArray = [];
                    var idPrimaryKey = null;
                    var featureHash = {};
                    for (let i = 0; i < data.features.length; i++) {
                        feature = (new GeoJSON()).readFeatures(data)[i];
                        idPrimaryKey = feature.getId().split(".")[1];
                        featureHash[idPrimaryKey] = feature;

                        // Save feature Search
                        myAvimTool._mapSgs._arraySearchLayerFeatureActive.push(feature);

                        // Build column info
                        var objRow = {};
                        for (var j = 0; j < Object.keys(feature.getProperties()).length; j++) {
                            var columnName = Object.keys(feature.getProperties())[j];
                            if (columnName === "geometry")
                                continue;
                            var value = feature.getProperties()[columnName];
                            var columnProperties = myAvimTool._mapSgs.layerTree.layerInfo.dict_layer_info[idLayer].list_column.filter(obj => {
                                return obj.column_name === columnName
                            })[0];

                            // If value is a system date, format string
                            //if (new Date(value) != 'Invalid Date' && isNaN(value))
                            if (columnProperties) {
                                if (columnProperties.column_type == 'xsd:date-time')
                                    value = myAvimTool._utility.TransformDateServerInDateTime(value);

                                objRow[columnName] = value;
                                if (columDefArrayExpandSize[columnName]) {
                                    if (value) {
                                        var valueSize = value.toString().length;
                                        columDefArrayExpandSize[columnName] = (valueSize > columDefArrayExpandSize[columnName]) ? valueSize : columDefArrayExpandSize[columnName];
                                    }
                                }
                                else {
                                    if (value)
                                        columDefArrayExpandSize[columnName] = value.toString().length;
                                    else
                                        columDefArrayExpandSize[columnName] = 30; // If fist empty
                                }
                                if (i === 0) {
                                    var columnSearchResult = myAvimTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).search_result;
                                    var visible = myAvimTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).visible;
                                    var columnPrettyName = myAvimTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).pretty_name;
                                    var searchResultOrder = myAvimTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).search_result_order;

                                    if (columnSearchResult) {
                                        columnDefArray.push({
                                            'data': columnName,
                                            'title': columnPrettyName,
                                            'name': columnPrettyName,
                                            'label': columnPrettyName,
                                            'type': columnPrettyName,
                                            'orderable': false,
                                            'width': '30px',
                                            'search_order': searchResultOrder
                                        });
                                    } else {
                                        columnDefArray.push({
                                            'data': columnName,
                                            'type': 'readonly',
                                            'visible': false,
                                            'search_order': 0
                                        });
                                    }
                                    if (visible) {
                                        columDefArrayExpand.push({
                                            'data': columnName,
                                            'title': columnPrettyName,
                                            'name': columnPrettyName,
                                            'label': columnPrettyName,
                                            'type': columnPrettyName,
                                            'orderable': false,
                                            'width': '30px'
                                        });
                                    }
                                    else {
                                        columDefArrayExpand.push({
                                            'data': columnName,
                                            'type': 'readonly',
                                            'visible': false
                                        });
                                    }
                                }
                            }
                        }
                        // Order columns by search order
                        columnDefArray = columnDefArray.sort((a, b) => (a.search_order > b.search_order) ? 1 : -1);

                        // Add primary key value
                        objRow["id_primary_key"] = idPrimaryKey;

                        // Add array row
                        columnValueArray.push(objRow);

                        // Put in feature highlight
                        myAvimTool._mapSgs.featureToHighLight.push(feature);
                        var styleElement = myAvimTool._mapSgs._defaultHighlighStyles;
                        myAvimTool._mapSgs.featureToHighLight.getArray()[myAvimTool._mapSgs.featureToHighLight.getArray().length - 1].setStyle(styleElement);
                    }

                    // Add primary key to array
                    columnDefArray.push({
                        'data': "id_primary_key",
                        'type': 'readonly',
                        'visible': false
                    });
                    columDefArrayExpand.push({
                        'data': "id_primary_key",
                        'type': 'readonly',
                        'visible': false
                    });

                    // Add size to column in array expand
                    for (let i = 0; i < columDefArrayExpand.length; i++) {
                        var objDef = columDefArrayExpand[i];
                        if (objDef.width) {
                            if (columDefArrayExpandSize[objDef.data] > 50)
                                objDef.width = columDefArrayExpandSize[objDef.data].toString() + "px";
                            else
                                objDef.width = "50px";
                            columDefArrayExpand[i] = objDef;
                        }
                    };

                    // Show canvas search result
                    myAvimTool._utility.ShowOpenCanvas3('offcanvas-search-result', true);

                    // Make datatable list
                    myAvimTool._mapSgs.InitSearchResultTable(workspace, layerName, idLayer, featureHash, columnDefArray, columDefArrayExpand, columnValueArray, myAvimTool._mapSgs.DetailElement);

                    // Go to Feature
                    if(myAvimTool._mapSgs.layerHighlightOverlay.getSource().getFeatures().length === 1 &&
                        myAvimTool._mapSgs.layerHighlightOverlay.getSource().getFeatures()[0].getGeometry().getType() === "Point")
                    {
                        myAvimTool._mapSgs.map.getView().fit(myAvimTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myAvimTool._mapSgs.map.getSize(), maxZoom: 12, duration: 1000  });
                    }
                    else
                        myAvimTool._mapSgs.map.getView().fit(myAvimTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myAvimTool._mapSgs.map.getSize() });

                    // Remove hide in offcanvas search result information
                    $('#id-offcanvas-search-result-zone').removeClass('ol-hidden');
                    $('#id-offcanvas-search-result-body').removeClass('ol-hidden');
                }
                else {
                    toastr["warning"]("Nehum imóvel encontrado");
                }
            }

            // Stop wait
            myAvimTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', false);
        });
    }

    /**
     * Get Placeholder Tag List
     * Extracts placeholders (enclosed by {{}} ) from template string
     * 
     * @param {object} newData - data to include in same name placeholders
     */
    this.getPlaceholderTagList = function (templateString) {
        var placeholderTagList = [];
        var placeholderInitFlag = false;
        var placeholderStringInitFlag = false;
        var placeholder = "";
        for (var i = 0; i < templateString.length; i++) {
            if (!placeholderInitFlag && templateString[i] == "{") {
                placeholderInitFlag = true;
                continue;
            }
            if (placeholderInitFlag && templateString[i] == "{") {
                placeholderInitFlag = false;
                placeholderStringInitFlag = true;
                continue;
            }
            if (placeholderStringInitFlag && templateString[i] != "}") {
                placeholder += templateString[i];
                continue;
            }
            if (placeholderStringInitFlag && templateString[i] == "}") {
                placeholderTagList.push(placeholder);
                placeholder = "";
                placeholderStringInitFlag = false;
            }
        }
        return placeholderTagList;
    }

    /**
     * Get Ajax Template
     * Returns a template string with replaced values
     * 
     * @param {object} newData - Data to include in placeholders with names equal to keys
     * @returns string replaceTemplate - Template with replaced values ready to include in HTML
     */
    this._GetAjaxTemplate = function (newData) {

        var replacedTemplate = this._ajaxTemplate; // Get the original template string
        var dataPlaceholders = myAvimTool.getPlaceholderTagList(replacedTemplate); // Get the placeholders to be replaced from template
        // Replace placeholders with values
        for (var i = 0; i < dataPlaceholders.length; i++) {
            replacedTemplate = replacedTemplate.split("{{" + dataPlaceholders[i] + "}}").join(newData[dataPlaceholders[i]]);
        }
        return replacedTemplate;
    }


    /**
     * Load Imovel Detail
     * Updates ajaxInjection array with HTML data string
     * 
     * @param {object} data - HTML data to increment in ajaxInjection array
     */
    this.loadImovelDetail = function (data) {

        var lowerCaseData = data.toLowerCase();
        // Get criteria from string to set in the given criteria on associative array
        var criteria = lowerCaseData.indexOf('criteria="proximidade"') != -1 ? 'proximidade' : (lowerCaseData.indexOf('criteria="rua"') != -1 ? 'rua' : 'predio');

        myAvimTool.ajaxInjection[criteria] = data + (typeof myAvimTool.ajaxInjection[criteria] != "undefined" ? myAvimTool.ajaxInjection[criteria] : "");
    }

    /**
     * Get layer by name
     * @param {ol.map} map, map
     * @param {any} layerName, layer name
     * @returns {ol.layer} layer
     */
    this.GetLayerByName = function (map, layerName) {
        var rLayer;

        var layers = map.getLayers().array_;

        layers.forEach(function (layer) {
            if (typeof layer.getProperties().name != "undefined") {
                if (layer.getProperties().name.indexOf(layerName) != -1) {
                    rLayer = layer;
                    return;
                }
            }
        });

        return rLayer;
    };

    /**
     * Reset address input
     */
    this._ResetAddressInput = function ()
    {
        $('#id-search-avim-address').val("");
        $('#id-search-avim-address').removeClass("disable-address-input");
        $('#id-search-avim-address').prop("disabled", false);
        $('#id-search-avim-address').addClass("required-data");
    }

    // -- end private method ----------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------

    /**
     * Click btn run simulation on details
     */
    $('#id-offcanvas-body-layer-detail-open-avim-tool-btn').off('click').on('click', function () {
        var options = { type: "ID", feature: window["temp_feature"] };
        myAvimTool.RunSimulation(options);
    });

    /**
     * Click btn run simulation on search form
     */
    $('.avim-search-simulate').off('click').on('click', function () {
        var formValid = true;

        var emptyFields = $(".required-data:not(div)").filter(function () {
            return !this.value;
        }).length;

        var invalidNumberFields = $(".field-numeric").filter(function () {
            return isNaN(this.value);
        }).length;

        var cp4Val = $('#id-avim-search-select-cp4').val();
        var cp3Val = $('#id-avim-search-select-cp3').val();
        if (cp4Val.length < 4 || cp3Val.length < 3) formValid = false;

        if (!emptyFields && !invalidNumberFields && formValid) {
            var options = { type: "FORM" };
            myAvimTool.RunSimulation(options);
        } else {
            toastr["warning"]("Campos obrigatórios não preenchidos.");
        }
    });

    /**
     * Click btn to set map location
     */
    $('.avim-search-map').off('click').on('click', function ()
    {
        if ($(this).hasClass('disabled')) {
            return;
        }

        if ($(this).hasClass('hover')) {
            $(this).addClass('hoverout');
        }
        $(this).removeClass('hover');

        if (!myAvimTool._markOnMapActivated)
        {
            $(this).addClass('hover');
            myAvimTool._markOnMapActivated = true;
            myAvimTool._goToCoordinates = true;
            myAvimTool._drawPointNewgeom.setActive(true);
        } else {
            myAvimTool._markOnMapActivated = false;
            myAvimTool._drawPointNewgeom.setActive(false);
        }
    });

    /**
     * Event to change distrito avim
     */
    $('#id-avim-search-select-distrito').off('change.bs.select').on('change.bs.select', function () {
        var idDistrito = $('#id-avim-search-select-distrito').val();
       
        $('#id-avim-search-select-localidade').find('option[value]').remove();
        $('#id-avim-search-select-localidade').selectpicker("refresh");
        myAvimTool._ResetAddressInput();
        $('#id-avim-search-porta').val("");
        $('#id-avim-search-andar').val("");
        $('#id-avim-search-select-cp4').val("");
        $('#id-avim-search-select-cp3').val("");
        $('#id-avim-search-select-designa-postal').val("");
        $('#id-avim-search-porta').val("");
        $('#id-avim-search-select-localidade option').remove();
        $('#id-avim-search-select-localidade').selectpicker("refresh");
        myAvimTool.updateAutocomplete("#id-search-avim-address", [], "morada");

        if (idDistrito === undefined || idDistrito === "") {
            $('#id-avim-search-select-concelho').find('option[value]').remove();
            $('#id-avim-search-select-concelho').selectpicker("refresh");
            $('#id-avim-search-select-freguesia').find('option[value]').remove();
            $('#id-avim-search-select-freguesia').selectpicker("refresh");
        }
        else {
            $('#id-avim-search-select-freguesia').find('option[value]').remove();
            $('#id-avim-search-select-freguesia').selectpicker("refresh");
            var arrayConcelho = myAvimTool._mapSgs._hashReference['concelho'][idDistrito];
            myAvimTool._mapSgs._utility.FillSelect('id-avim-search-select-concelho', arrayConcelho, myAvimTool._mapSgs.hashConcelhoInfo.desc_column, myAvimTool._mapSgs.hashConcelhoInfo.id_column, true);

            // Goto district
            if (!myAvimTool._goToCoordinates) {
                var featureLocation = myAvimTool._mapSgs._hashReferenceFeature.distrito[idDistrito];
                myAvimTool._mapSgs.SetFeaturesHighlightByArray3(featureLocation, true, myAvimTool._limitHighlighStyles);
            }

            if (typeof myAvimTool.change_select_callback != "undefined") {
                myAvimTool.change_select_callback();
            }
        }
    });

    /**
     * Event on change concelho on address search
     */
    $('#id-avim-search-select-concelho').off('change.bs.select').on('change.bs.select', function () {
        
        $('#id-avim-search-select-localidade').find('option[value]').remove();
        $('#id-avim-search-select-localidade').selectpicker("refresh");
        myAvimTool._ResetAddressInput();
        $('#id-avim-search-porta').val("");
        $('#id-avim-search-andar').val("");
        $('#id-avim-search-select-cp4').val("");
        $('#id-avim-search-select-cp3').val("");
        $('#id-avim-search-select-designa-postal').val("");
        $('#id-avim-search-porta').val("");
        $('#id-avim-search-select-localidade option').remove();
        $('#id-avim-search-select-localidade').selectpicker("refresh");
        myAvimTool.updateAutocomplete("#id-search-avim-address", [], "morada");

        var dd = $('#id-avim-search-select-distrito').val();
        var ddcc = $('#id-avim-search-select-concelho').val();

        if (ddcc == "") {
            $('#id-avim-search-select-localidade option').remove();
            $('#id-avim-search-select-localidade').selectpicker("refresh");
            return;
        }

        var cc = "";
        if (ddcc)
            cc = ddcc.substr(2);

        // Goto concelho
        if (!myAvimTool._goToCoordinates) {
            var featureLocation = myAvimTool._mapSgs._hashReferenceFeature.concelho[ddcc];
            if(typeof featureLocation != "undefined")
                myAvimTool._mapSgs.SetFeaturesHighlightByArray3(featureLocation, true, myAvimTool._limitHighlighStyles);
        }

        // Get all localidade from concelho
        $.ajax({
            type: 'GET',
            url: '/rest/app/AvimTool/GetLocalidadeByDDCC?dd=' + dd + "&cc=" + cc,
            xhrFields: {
                withCredentials: true
            },
            async: true,
            dataType: 'json',
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro ao obter localidades");
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            // Empty select
                            $('#id-avim-search-select-localidade').find('option:not(":first")').remove()
                            $($('#id-avim-search-select-localidade').siblings()[1]).find('li').remove();
                            // Fill select
                            myAvimTool._mapSgs._utility.FillSelect('id-avim-search-select-localidade', data.result.res, "localidade", "cc", true);
                            if (typeof myAvimTool.change_select_callback != "undefined") {
                                myAvimTool.change_select_callback();
                            }
                            break;
                        case "NOT_FOUND":
                            toastr["warning"]("Nenhuma localidade encontrada");
                            break;
                        default:
                            toastr["error"]("Erro ao obter localidades");
                            break;
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro ao obter localidades");
            }
        });
    });
       
    /**
     * On change of door number
     */
    $("#id-avim-search-porta").off("change").on("change", function ()
    {
        // On change of Porta, set CP3 if not already set
        var address = $('#id-search-avim-address').val();
        var addressList = myAvimTool.sourceTags.filter(s => s.morada.toUpperCase() == address.toUpperCase());
        var porta = $(this).val();
        // CP3 only needs to be set in case of multiple cp3 for same address
        if (addressList.length > 1) {
            // Consider only door numbers that start by number
            if (!isNaN(porta[0])) {
                var numericPorta = myAvimTool.getNumericPorta(porta); // Numeric portion of door
                // If porta matches single door number for ctt address
                var specificAddress = addressList.filter(s => s.fiM_NUM == null && s.inI_NUM == porta);
                if (specificAddress.length == 1) {
                    $('#id-avim-search-select-cp4').val(specificAddress[0].cp4);
                    $('#id-avim-search-select-cp3').val(specificAddress[0].cp3);
                } else {
                    // If porta is in range for generic ctt address range
                    var genericRange = addressList.filter(s => s.i_P == null && s.inI_NUM != null && myAvimTool.getNumericPorta(s.inI_NUM) <= parseInt(numericPorta) && s.fiM_NUM != null && myAvimTool.getNumericPorta(s.fiM_NUM) >= parseInt(numericPorta));
                    if (genericRange.length == 1) {
                        $('#id-avim-search-select-cp4').val(genericRange[0].cp4);
                        $('#id-avim-search-select-cp3').val(genericRange[0].cp3);
                    } else {
                        // If porta is in range for odd or even ctt address range
                        var oddEven = numericPorta % 2 == 0 ? "Pares" : "Ímpares";
                        var oddEvenRange = addressList.filter(s => s.i_P == oddEven && s.inI_NUM != null && myAvimTool.getNumericPorta(s.inI_NUM) <= parseInt(numericPorta) && s.fiM_NUM != null && myAvimTool.getNumericPorta(s.fiM_NUM) >= parseInt(numericPorta));
                        if (oddEvenRange.length == 1) {
                            $('#id-avim-search-select-cp4').val(oddEvenRange[0].cp4);
                            $('#id-avim-search-select-cp3').val(oddEvenRange[0].cp3);
                        }
                        else
                        {
                            toastr["warning"]("Número de porta não existe neste arruamento");
                            $('#id-avim-search-select-cp3').val("");
                        }
                    }
                }
            }
        }
    });

    /**
     * On localidade change selection
     */
    $('#id-avim-search-select-localidade').off('change.bs.select').on('change.bs.select', function ()
    {
        myAvimTool._ResetAddressInput();
        $('#id-avim-search-porta').val("");
        $('#id-avim-search-andar').val("");
        $('#id-avim-search-select-cp4').val("");
        $('#id-avim-search-select-cp3').val("");
        $('#id-avim-search-select-designa-postal').val("");
        $('#id-avim-search-porta').val("");
        myAvimTool.updateAutocomplete("#id-search-avim-address", [], "morada");

        myAvimTool.localidadeVal = $('#id-avim-search-select-localidade').val();
        myAvimTool.distritoVal = $('#id-avim-search-select-distrito option:selected').text();
        myAvimTool.concelhoVal = $('#id-avim-search-select-concelho option:selected').text();

        var dd = $('#id-avim-search-select-distrito').val();
        var ddcc = $('#id-avim-search-select-concelho').val();

        if (myAvimTool.localidadeVal != "") {

            $.ajax({
                type: 'GET',
                url: '/rest/app/AvimTool/GetRuaByLocalidade?localidade=' + $('#id-avim-search-select-localidade').val() + '&dd=' + dd + '&cc=' + ddcc.substr(2,2),
                xhrFields: {
                    withCredentials: true
                },
                async: true,
                dataType: 'json',
                success: function (data) {
                    if (data.error) {
                        toastr["error"]("Erro ao obter localidades");
                    }
                    else
                    {
                        $("#id-search-avim-address").val("");
                        $("#id-avim-search-porta").val("");
                        $("#id-avim-search-andar").val("");

                        if (typeof myAvimTool._mapSgs.searchCoord == "undefined") {
                            myAvimTool.gotoGeocode(myAvimTool.localidadeVal + ", " + myAvimTool.concelhoVal + ", " + myAvimTool.distritoVal + ", Portugal");
                            myAvimTool._mapSgs.featureToHighLight.clear();
                        }
                        delete myAvimTool._mapSgs.searchCoord;

                        switch (data.result.status) {
                            case "NO_CP":
                                toastr["error"]("Erro ao obter localidades");
                                break;
                            case "NO_ADDRESS":
                                if (typeof data.result != 'undefined' && typeof data.result.res != 'undefined')
                                {
                                    var limitResult = data.result.res;
                                    myAvimTool.sourceTags = [];

                                    $('#id-search-avim-address').addClass("disable-address-input");
                                    $('#id-search-avim-address').removeClass("required-data");
                                    $('#id-search-avim-address').prop("disabled", true);
                                    $("#id-avim-search-select-cp4").val(limitResult[0].cP4);
                                    $("#id-avim-search-select-designa-postal").val(limitResult[0].ncpalf);
                                    $("#id-avim-search-select-cp3").val(limitResult[0].cP3);

                                    toastr["warning"]("Localidade sem arruamento disponível");
                                }
                                else
                                {
                                    toastr["error"]("Erro ao obter localidades");
                                }
                                break;
                            case "WITH_ADDRESS":
                                if (typeof data.result != 'undefined' && typeof data.result.res != 'undefined')
                                {
                                    var limitResult = data.result.res;
                                    myAvimTool.sourceTags = [];

                                    for (var l = 0; l < limitResult.length; l++) {
                                        myAvimTool.sourceTags.push({ "morada": limitResult[l].arT_TipoTituloDesig, "cp4": limitResult[l].cP4, "cp3": limitResult[l].cP3, "designa": limitResult[l].ncpalf, "i_P": limitResult[l].i_P, "inI_NUM": limitResult[l].inI_NUM, "fiM_NUM": limitResult[l].fiM_NUM });
                                    }

                                    myAvimTool.updateAutocomplete("#id-search-avim-address", myAvimTool.sourceTags, "morada");

                                    if (typeof myAvimTool._mapSgs.chosenAddress != "undefined" && myAvimTool._mapSgs.chosenAddress.streetAddress != "") {
                                        var existingAddress = myAvimTool.sourceTags.filter(m => m.morada.toUpperCase() == myAvimTool._mapSgs.chosenAddress.streetAddress.toUpperCase());
                                        if (!existingAddress.length) {

                                            // If address not found, remove connective words until found or no more words to remove
                                            var replaceWord = null;
                                            do {
                                                // Replace first connective particle
                                                replaceWord = myAvimTool.replaceFirstConnectiveWord(myAvimTool._mapSgs.chosenAddress.streetAddress);
                                                // Update address
                                                myAvimTool._mapSgs.chosenAddress.streetAddress = replaceWord.newAddress;
                                                // Re-test address 
                                                existingAddress = myAvimTool.sourceTags.filter(m => m.morada.toUpperCase() == myAvimTool._mapSgs.chosenAddress.streetAddress.toUpperCase());
                                            } while (!existingAddress.length && replaceWord.moreParticlesToReplace)
                                
                                        }
                                        if (existingAddress.length) {
                                            $("#id-search-avim-address").val(existingAddress[0].morada);
                                            if (typeof myAvimTool._mapSgs.chosenAddress.streetNo != "undefined")
                                                $("#id-avim-search-porta").val(myAvimTool._mapSgs.chosenAddress.streetNo);
                                        }
                                        $("#id-search-avim-address").autocomplete('option', 'change')();
                                        delete myAvimTool._mapSgs.chosenAddress;
                                    }
                                }
                                else
                                {
                                    toastr["error"]("Erro ao obter localidades");
                                }
                                break;
                            case "ERROR":
                                toastr["error"]("Erro ao obter localidades");
                                break;
                            default:
                                // do nothing
                        }
                    }

                    // Stop wait
                    myAvimTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                },
                error: function (request, status, error) {
                    toastr["error"]("Erro ao obter localidades");
                    // Stop wait
                    myAvimTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                }
            });
        }
    });

    /**
     * Tab navigation
     */
    $('#id-modal-avim-tool-tab-option.nav-tabs a').click(function(){

        $('.tab-pane').removeClass('active');
        $('.nav-tabs li').removeClass('active');
        console.log($(this).attr('href'));
        $($(this).attr('href')).addClass('active');
        $(this).parent().addClass("active");

    });

    /**
     * Close modal avim tool
     */
    $('#id-modal-avim-tool-close').off('click').on('click', function () {
        $('#id-modal-simulation-avim').css({ 'display': 'none' });
    });

    // -- end event -------------------------------------------------------------------------------
};

/**
 * Init map street view information
 * @param {ol.map} map, ol map
 */
AvimTool.prototype.Init = function (MapSgs)
{
    // Keep map sgs
    this._mapSgs = MapSgs;

    // Set reference
    this._mapSgs._GetAllReference();

    // This object 
    var objAvimTool = this;

    // Set reference avim
    this.GetAllReference();

    // Init slider radius for simulation
    //if (!this._radiusSimulationSlider)
    //{
    //    this._radiusSimulationSlider = new Slider("#id-avim-search-radius-slider", {
    //        step: 10,
    //        min: this._minRadiusSimulation,
    //        max: this._maxRadiusSimulation,
    //        value: this._valueRadiusSimulationInit,
    //        tooltip: 'hide',
    //        width: '600px'
    //    });
    //}
    $('#id-avim-search-raio').val(this._valueRadiusSimulationInit);

    //// Update index value radius
    //this._radiusSimulationSlider.on("slide", function (sliderValue)
    //{
    //    $('#id-avim-search-raio').val(sliderValue);
    //});

    // -- Buil layer for location simulation ------------------------------------------------------
    var source = new VectorSource({ wrapX: false });
    this._avimVectorPoint = new VectorLayer({
        source: source,
        style: objAvimTool._styleSimulationLocation
    });

    this._mapSgs.map.addLayer(this._avimVectorPoint);

    this._drawPointNewgeom = new Draw({
        source: source,
        type: 'Point',
        style: objAvimTool._styleSimulationLocation
    });
    this._drawPointNewgeom.setActive(false);

    // Add interaction but disable for now
    this._mapSgs.map.addInteraction(this._drawPointNewgeom);

    // Event drawend point location
    this._drawPointNewgeom.on('drawstart', function (evt)
    {
        // Clear previous selection
        objAvimTool._ClearAllPinLocation();
    });

    // Event drawend point location
    this._drawPointNewgeom.on('drawend', function (evt)
    {
        // Start wait
        objAvimTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', true);
                    
        $('.avim-search-map').removeClass('hover');
        $('.avim-search-map').removeClass('hover');
        $('.avim-search-map').addClass('hoverout');

        objAvimTool._markOnMapActivated = false;
        objAvimTool._drawPointNewgeom.setActive(false);
        delete objAvimTool.change_select_callback;

        var projectionMap = objAvimTool._mapSgs._settings._mapSettings.map_info.srs_srid.toString();
        objAvimTool._mapSgs.searchCoord = proj4('EPSG:' + projectionMap, 'EPSG:4326', [evt.target.sketchCoords_[0], evt.target.sketchCoords_[1]]);

        $.ajax({
            type: 'GET',
            url: '/rest/app/AvimTool/GetFreguesiaByCoord?xCoord=' + objAvimTool._mapSgs.searchCoord[0] + '&yCoord=' + objAvimTool._mapSgs.searchCoord[1],
            xhrFields: {
                withCredentials: true
            },
            async: true,
            dataType: 'json',
            success: function (data)
            {
                delete objAvimTool.freguesiaVal; // Restart freguesia value
                if (typeof data.result != 'undefined' && typeof data.result.res != 'undefined' && data.result.res.length > 0) {

                    // Collect info on CAOP
                    objAvimTool.dd = data.result.res[0].dd;
                    objAvimTool.cc = data.result.res[0].cc;
                    objAvimTool.freguesiaVal = data.result.res[0].freguesia;
                    objAvimTool.distritoSelect = $('#id-avim-search-select-distrito');
                    objAvimTool.concelhoSelect = $('#id-avim-search-select-concelho');
                    // Fill Distrito and trigger callback
                    objAvimTool.distritoSelect.val(objAvimTool.dd);
                    objAvimTool.distritoSelect.selectpicker("refresh");
                    objAvimTool.change_select_callback = objAvimTool.distritoCallback;
                    objAvimTool.distritoSelect.trigger('change.bs.select');
                } else {
                    toastr["error"]("Erro ao obter freguesia");
                    // Stop wait
                    objAvimTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro ao obter freguesia");

                // Stop wait
                objAvimTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    });
};
